import { render, staticRenderFns } from "./config-field.vue?vue&type=template&id=6f6a94ec&scoped=true"
import script from "./config-field.vue?vue&type=script&lang=js"
export * from "./config-field.vue?vue&type=script&lang=js"
import style0 from "./config-field.vue?vue&type=style&index=0&id=6f6a94ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6a94ec",
  null
  
)

export default component.exports